import { JsonUtils } from '../../utils/json.util'

export class ActiveSearchCity {

    private _total: number | undefined
    private _promoted: number | undefined
    private _rejected: number | undefined
    private _pending: number | undefined
    private _city: string | undefined

    get total(): number | undefined {
        return this._total
    }
    set total(value: number | undefined) {
        this._total = value
    }
    get promoted(): number | undefined {
        return this._promoted
    }

    set promoted(value: number | undefined) {
        this._promoted = value
    }
    get rejected(): number | undefined {
        return this._rejected
    }
    set rejected(value: number | undefined) {
        this._rejected = value
    }

    get pending(): number | undefined {
        return this._pending
    }
    set pending(value: number | undefined) {
        this._pending = value
    }
    get city(): string | undefined {
        return this._city
    }
    set city(value: string | undefined) {
        this._city = value
    }

    public fromJSON(json: any): ActiveSearchCity {
        if (!json) {
            return this
        }
        if (typeof json === 'string') {
            if (!JsonUtils.isJsonString(json)) {
                return this
            }
            json = JSON.parse(json)
        }

        if (json.total !== undefined) {
            this.total = json.total
        }
        if (json.promoted_total !== undefined) {
            this.promoted = json.promoted
        }
        if (json.rejected !== undefined) {
            this.rejected = json.rejected
        }
        if (json.pending !== undefined) {
            this.pending = json.pending
        }
        if (json.city !== undefined) {
            this.city = json.pending
        }
        return this
    }
    public toJSON(): any {
        return {
            total: this.total || undefined,
            promoted: this.promoted || undefined,
            rejected: this.rejected || undefined,
            pending: this.pending || undefined,
            city: this.city || undefined
        }
    }


}